import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 0,
  class: "text-h6 q-pa-md"
}

import { PropType, ref, onMounted, computed } from "vue";
  import { QInput } from "quasar";
  import { LenderQuote, LoanApplication } from "src/types/loan-application/index";
  import { ProductType_Enum } from "src/types/enums/index";
  import CurrencyInput from "src/components/form/inputs/CurrencyInput.vue";
  import Flag from "src/components/shared/Flag.vue"
  import { useCurrencyFormatter } from 'src/functions';
  import DataTable from "src/components/form/forms/DataTable.vue";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'LenderQuoteForm',
  props: {
    lenderQuote: {
      type: Object as PropType<LenderQuote>,
      default: {} as LenderQuote
    },
    showTitle: {
      type: Boolean,
      default: true
    }
  },
  emits: [
    'update:lenderQuote'
  ],
  setup(__props, { emit: __emit }) {

  const props = __props

  const value = computed<LenderQuote>({
    get() {
      return props.lenderQuote
    },
    set(value: LenderQuote) {
      emit('update:lenderQuote', value)
    }
  })

  const emit = __emit

  const lenderQuoteTable = computed(() =>
  {
    let data =
      [
      { label: "Product Type", value: ProductType_Enum[value.value.quoteProductType] },
      { label: "Lender Name", value: value.value.lender },
      { label: "APR", value: value.value.apr + "%" },
      { label: value.value.quoteProductType == ProductType_Enum.PCP ? "Optional Final Payment" : "Final Payment", value: value.value.optionalFinalPayment ? useCurrencyFormatter(value.value.optionalFinalPayment, 2, 2) : "-" },
      { label: "Option to Purchase Fee", value: value.value.optionToPurchaseFee ? useCurrencyFormatter(value.value.optionToPurchaseFee, 2, 2) : "-" },
      { label: "Total Cost of Credit", value: value.value.totalCostOfCredit ? useCurrencyFormatter(value.value.totalCostOfCredit, 2, 2) : "-" }
      ]

    if (value.value.quoteProductType == ProductType_Enum.PCP)
    {
      data.push({ label: "Annual Mileage Limit", value: value.value.annualMileageLimit + " miles" });
      data.push({ label: "Excess Mileage Charge", value: value.value.excessMileageCharge ? useCurrencyFormatter(value.value.excessMileageCharge, 2, 2) + "/mile" : "-" });
    }
    data.push({ label: "Total Repayable", value: value.value.totalRepayable ? useCurrencyFormatter(value.value.totalRepayable, 2, 2) : "-" });
    data.push({ label: "Monthly Payments", value: value.value.monthlyPayment ? useCurrencyFormatter(value.value.monthlyPayment, 2, 2) : "-" });
    return data;
  })

return (_ctx: any,_cache: any) => {
  const _component_q_separator = _resolveComponent("q-separator")!

  return (lenderQuoteTable.value != null)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (__props.showTitle)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, " Lender Quote "))
          : _createCommentVNode("", true),
        (__props.showTitle)
          ? (_openBlock(), _createBlock(_component_q_separator, {
              key: 1,
              style: {"border-width":"3px !important"}
            }))
          : _createCommentVNode("", true),
        _createElementVNode("div", null, [
          _createVNode(DataTable, { data: lenderQuoteTable.value }, null, 8, ["data"])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})